import React, { Component } from "react";
import { Link } from "react-router-dom";
// import { BADRINATH } from "../Constant/Constants";

import { Icon } from "@iconify/react";
import {
  BADRI_NATH,
  img_url2,
  img_url3,
  img_url4,
  img_url5,
  img_url6,
  img_url7,
  img_url8,
} from "../Constant/Constants";

export class Viewall extends Component {
  render() {
    return (
      <>
        <div
          className="grid_images"
          style={{
            // border: "1px solid red",
            height: "50px",
            width: "100%",
            marginTop: "50px",
            marginBottom:"1300px"
          }}
        >
          <div className="image_box">
            {/* <a href="https://en.wikipedia.org/wiki/Ram_Mandir"> */}

            <a href="https://localhost:3000/badrinath_temple">
              <div className="img_div">
                <img className="imgbox" src={img_url2} alt="img"></img>
                <h5 className="grid_temple_name">Badrinath Temple</h5>

                <Icon
                  className="grid_temple_icon"
                  icon="akar-icons:location"
                  width="20"
                />

                <p className="grid_temple_location">Badrinath, Uttarakhand</p>
              </div>
            </a>

            {/* </a> */}
            {/* <a href={img_url3}> */}
            <div className="img_div">
              <img className="imgbox" src={img_url4}></img>
              <h5 className="grid_temple_name">Kashi Vishwanath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Varanasi, Uttar Pradesh</p>
            </div>
            {/* </a> */}

            {/* <a href="https://en.wikipedia.org/wiki/Kailasanathar_Temple,_Kanchi"> */}
            <div className="img_div">
              <img className="imgbox" src={img_url5}></img>
              <h5 className="grid_temple_name">Golden Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Amritsar, Punjab</p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Ulagalantha_Perumal_Temple,_Kanchipuram"> */}
            <div className="img_div">
              <img className="imgbox" src={img_url6}></img>
              <h5 className="grid_temple_name">Vaishno Devi Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">
                Vaishno Devi, Jammu & Kashmir
              </p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Tirunallar_Dharbaranyeswarar_Temple"> */}
            <div className="img_div">
              <img className="imgbox" src={img_url7}></img>
              <h5 className="grid_temple_name">Akshardham Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">New Delhi, Delhi</p>
            </div>
            {/* </a> */}
            {/* <a href=""> */}
            <div className="img_div">
              <img className="imgbox" src={img_url8}></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Vadakkunnathan_Temple"> */}
            <div className="img_div">
              <img
                className="imgbox"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhTlYbRNnWiwVffv8vYgQDEsu2zOV_cq5gFg&usqp=CAU"
              ></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Jagannath_Temple,_Puri"> */}
            <div className="img_div">
              <img
                className="imgbox"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR82htotpYSNxtuaFfpUWJYBqMeKYAWkiU4SA&usqp=CAU"
              ></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Ram_Mandir"> */}
            <div className="img_div">
              <img className="imgbox" src={img_url2}></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </div>
            {/* </a> */}
            {/* <a href={img_url3}> */}
            <div className="img_div">
              <img className="imgbox" src={img_url4}></img>
              <h5 className="grid_temple_name">Kashi Vishwanath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Varanasi, Uttar Pradesh</p>
            </div>
            {/* </a> */}

            {/* <a href="https://en.wikipedia.org/wiki/Kailasanathar_Temple,_Kanchi"> */}
            <div className="img_div">
              <img className="imgbox" src={img_url5}></img>
              <h5 className="grid_temple_name">Golden Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Amritsar, Punjab</p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Ulagalantha_Perumal_Temple,_Kanchipuram"> */}
            <div className="img_div">
              <img className="imgbox" src={img_url6}></img>
              <h5 className="grid_temple_name">Vaishno Devi Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">
                Vaishno Devi, Jammu & Kashmir
              </p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Tirunallar_Dharbaranyeswarar_Temple"> */}
            <div className="img_div">
              <img className="imgbox" src={img_url7}></img>
              <h5 className="grid_temple_name">Akshardham Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">New Delhi, Delhi</p>
            </div>
            {/* </a> */}
            {/* <a href=""> */}
            <div className="img_div">
              <img className="imgbox" src={img_url8}></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Vadakkunnathan_Temple"> */}
            <div className="img_div">
              <img
                className="imgbox"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhTlYbRNnWiwVffv8vYgQDEsu2zOV_cq5gFg&usqp=CAU"
              ></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </div>
            {/* </a> */}
            {/* <a href="https://en.wikipedia.org/wiki/Jagannath_Temple,_Puri"> */}
            <div className="img_div">
              <img
                className="imgbox"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR82htotpYSNxtuaFfpUWJYBqMeKYAWkiU4SA&usqp=CAU"
              ></img>
              <h5 className="grid_temple_name">Badrinath Temple</h5>
              <Icon
                className="grid_temple_icon"
                icon="akar-icons:location"
                width="20"
              />
              <p className="grid_temple_location">Badrinath, Uttarakhand</p>
            </div>
            {/* </a> */}
          </div>
        </div>
      </>
    );
  }
}

export default Viewall;
